import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('authtoken');
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && (result.error.status === 401)) {
    localStorage.removeItem('authtoken');
  }
  return result;
};

export const PlanApi = createApi({
  reducerPath: 'PlanApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getPlanList: builder.query({
      query: (param) => ({
        url: `/plans/get-plan/`,
        params:param
      })
    }),
    getAllPlanList: builder.query({
      query: (param) => ({
        url: `/plans/get-plans/`,
        params:param
      })
    }),
    postPlan: builder.mutation({
      query: (data) => ({
        url: `/plans/plan-create/`,
        method: "POST",
        body: data,
      }),
    }),
    deletePlan: builder.mutation({
      query: (id) => {
        return {
          url: `/plans/plans-delete/${id}/`,
          method: "DELETE",
        };
      },
    }),
    updatePlan: builder.mutation({
      query: ({ id, data }) => (
    
        
        {
        url: `/plans/plans-update/${id}/`,
        method: "PUT",
        body: data,

      }),
    }),

        getAdminPlans: builder.query({
      query: (param) => ({
        url: `/adminplan/admin-plans-create/`,
        params: param
      })
    }),

  }),
})

export const {useGetAllPlanListQuery, useGetPlanListQuery, usePostPlanMutation, useDeletePlanMutation, useUpdatePlanMutation,useGetAdminPlansQuery  } = PlanApi